import React from "react";
import { getTeamData } from "../../utils/is.after";
import {
  approvedStatusDataLayer,
  documentUnderReviewDataLayer,
  documentUploadedStatusDataLayer
} from "../../analytics/adobe/pendDataLayerValues";
import { setPageNameSiteSection, updateStandardDataLayerAttributes } from "../../analytics/adobe";
import { confirmDataLayer } from "../../analytics/adobe/dataLayerValues";

export class ConfirmPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      legalCheckBoxChecked: false,
      target: true,
      extraParam: false
    };
  }

  componentWillMount() {
    let offer = this.props.offerPreFilled.offerAcceptDetails;
    const teamData = getTeamData(this.props.offerPreFilled.channelSource);
    this.setState({
      legalCheckBoxChecked: offer.legalTermsAndCondition
    });
    if(teamData !== null){
      this.setState({
        target: teamData.target,
        extraParam: teamData.extraParam
      });
    }
  }


  handleCheckClick = () => {
    this.setState({ legalCheckBoxChecked: !this.state.legalCheckBoxChecked });
  };
  enableBtn = () => {
    let enableDisableBtn = (this.state.legalCheckBoxChecked === true) ? false : true;
    return enableDisableBtn;
  };
  componentDidMount() {
    const { pageName, siteSection }=(this.props.offerPreFilled.pendFlow?approvedStatusDataLayer:confirmDataLayer);
    updateStandardDataLayerAttributes(setPageNameSiteSection(pageName, siteSection), true);
  }
  acceptOffer = () => {
    const actionUrl = (this.props.offerPreFilled.pendFlow?"customizePendingOffer":"customizeOffer");
    const url =`/clapply/action/${actionUrl}/agreement`;
    this.props.storeTermsInSession({
      "legalTermsAndCondition": this.state.legalCheckBoxChecked
    }, { mover: this.props.history, nextPage: url });
  };
  render = () => {
    const target =(this.state.target?{ target: "_blank" }:{});
    const { crossSellPersonalizedQuote, rewardEnabled } = this.props.offerPreFilled;
    const showPopUp=(this.state.extraParam?"?showPopUp=true":"");
    const showpdf=(this.state.extraParam?"&showpdf=true":"");
    const showPopUpLegal=(this.state.extraParam?"&showPopUp=true":"");
    return (
      <section className="section-width col-sm-12 col-md-12 col-lg-12 margin-t-m-10 border-round confirmPage">
        <div className="loan-details">
          <p className="deposit-my-loan standard-blue">
              Read your loan forms
          </p>
          <p className="deposit-my-loan your-loan-light-grey">
              Before you continue, please review the below loan documents:
          </p>
          <ul className="list-group accept-terms-list">
            <li className="list-group-item ">
              <a data-track="custom-links" className="" href={`/clapply/cyr/econsent.html${showPopUp}`} {...target}><span> Electronic Consent Terms & Conditions</span>
                <span className="arrow arrow-loan arrow-right"></span>
              </a>
            </li>
            <li className="list-group-item ">
              <a data-track="custom-links" className="" href={`/clapply/action/customizeOffer?getCreditScoreNoticeDisclosurePDF=${showpdf}`} {...target}>
                <span>Credit Score Notice Disclosure</span> <span className="arrow arrow-loan arrow-right"></span>
              </a>
            </li>
            <li className="list-group-item ">
              <a data-track="custom-links" className="" href={`/clapply/cl/CLCyr.action?legalTerms=${showPopUpLegal}`} {...target}> <span>Legal Terms & Conditions</span>
                <span className="arrow arrow-loan arrow-right"></span>
              </a>

            </li>
            <li className="list-group-item ">
              <a data-track="custom-links" className="" href={`https://cards.barclaycardus.com/banking/privacy-policy/${showPopUp}`} {...target}> <span>Privacy Policy</span>
                <span className="arrow arrow-loan arrow-right"></span>
              </a>

            </li>
            {

              rewardEnabled?
                <li className="list-group-item ">
                  <a data-track="custom-links" className="" href={`/clapply/action/customizeOffer/rewardsdisclosure${showPopUp}`} {...target}>
                    <span>Rewards Disclosure</span> <span className="arrow arrow-loan arrow-right"></span>
                  </a>
                </li>
                : null
            }
          </ul>

          <div className="custom-control custom-checkbox mb-3 custom-control-checkbox standard-blue accept-terms">
            <input type="checkbox" className="custom-control-input" id="terms" name="terms"
              checked={this.state.legalCheckBoxChecked}
              onChange={this.handleCheckClick}
              aria-labelledby="terms-acceptance-label"
            />
            <label className="custom-control-label text-wrap-pre" htmlFor="terms"></label>
            <span className=" your-loan-light-grey" id="terms-acceptance-label"> By checking the box, you acknowledge that you have read and agreed to the terms listed above.</span>
          </div>
        </div>
        <section className="col-12 text-btn-center add-bank m-m-15 accept-offer-mobile">
          <button data-track="custom-links" type="submit" className="accept-offer-btn button-override-color margin-t-0-btn"
            disabled={this.enableBtn()} onClick={this.acceptOffer}>Accept offer
          </button>
        </section>
      </section>
    );
  };
}

export default ConfirmPage;
